import { STORAGE_KEY } from "@constants";
import { getMemberSettings } from "@utils/member-settings";
import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import bengaliTranslation from "./locales/bn.json";
import englishTranslation from "./locales/en.json";
import indonesiaTranslation from "./locales/id.json";
import thailandTranslation from "./locales/th.json";
import urduTranslation from "./locales/ur.json";
import { PersistLanguage } from "./plugins";

const resources = {
  en: {
    translation: englishTranslation,
  },
  th: {
    translation: thailandTranslation,
  },
  id: {
    translation: indonesiaTranslation,
  },
  bn: {
    translation: bengaliTranslation,
  },
  ur: {
    translation: urduTranslation,
  },
};

i18next.use(PersistLanguage).use(initReactI18next);

export const initI18n = (lng?: string) => {
  i18next.init({
    resources,
    lng,
    debug: false,
  });
};

const memberSettings = getMemberSettings();

const lng = localStorage.getItem(STORAGE_KEY.LANGUAGE) ?? memberSettings.language;

initI18n(lng);

export default i18next;
